import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
	nickname: '',
	userId: '',
	balance: 0,
	credits: 0,
}

export default {
	state,
	getters,
	actions,
	mutations
};